<template>
    <v-row class="allParams">
        <v-col cols="3" sm="3" style="padding: 0">
            <div class="extra">
                <span>Extra params</span>
            </div>
        </v-col>
        <v-col cols="6" sm="6" style="max-width: 400px">
            <div class="flex row right-align">
                <v-row v-for="(param, index) in params" :key="index" class="right-align">
                    <v-col cols="5" sm="5">
                        <v-text-field
                                v-model="param.name"
                                dense
                                placeholder="Param Name"
                                class="custom-placeholder"
                        />
                    </v-col>
                    <v-col cols="5" sm="5">
                        <v-text-field
                                dense
                                v-model="param.value"
                                placeholder="Param Value"
                                class="custom-placeholder"
                        />
                    </v-col>
                    <v-col cols="2" sm="2" class="remove">
                        <button
                                style="background:var(--v-primary-base);border-radius:5px; height:33px;width:33px;margin-right:1px;margin-top:-10px"
                                @click="removeParam(index)"
                        >
                            <v-icon size="23" color="white">mdi-trash-can-outline</v-icon>
                        </button>
                    </v-col>
                </v-row>
                <v-row class="right-align"  v-if="currentVariant">
                    <v-col cols="5" sm="5"></v-col>
                    <v-col cols="5" sm="5"></v-col>
                    <v-col cols="2" sm="2" class="remove">
                        <v-btn
                                @click="addParam"
                                style="background:var(--v-primary-base);border-radius:5px;min-width:34px;width:34px; height: 34px"
                        >
                            <v-icon color="white">mdi-plus</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </div>
        </v-col>
    </v-row>
</template>

<script>
    export default {
        name: 'ExtraParamsComponent',
        props: {
          extraParams: Array,
          isInit: Boolean,
          currentVariant: Object
        },
        data() {
            return {
                params: [],
            };
        },
        mounted() {
          if (this.isInit) {
              this.addParam();
          }
        },
        methods: {
            addParam() {
                if (!this.params.find((p) => p.name === '' || p.value === '') || !this.params.length) {
                    this.params.push({ name: '', value: '' });
                }
            },
            removeParam(index) {
                this.params.splice(index, 1);
            },
            getLocalParams() {
                this.sanitizeParams();
                return this.params;
            },
            sanitizeParams() {
                this.params = this.params.map(param => ({
                    name: param.name.replace(/\s+/g, ''),
                    value: param.value.replace(/\s+/g, ''),
                }));
            }
        },
        watch: {
            extraParams: {
                handler(newParams) {
                    if (newParams && newParams.length) {
                        this.params = [...newParams];
                    }
                },
                deep: true,
                immediate: true
            }
        }
    };
</script>

<style scoped>
    .allParams {
        margin: 3% 0;
    }
    .extra {
        display: flex;
        align-items: center;
        margin-bottom: 2%;
    }
    .custom-placeholder::placeholder {
        color: var(--v-primary-base);
    }
    .remove {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0;
        margin: 0;
    }
    .right-align {
        display: flex;
        justify-content: flex-end;
    }

</style>
